import React, { useEffect, useState } from "react";
import CustomItemModal from "./CustomItemModal";
import { CircularProgress, Box, Dialog } from "@mui/material";

const EditCustomBoothItemModal = ({ open, onClose, data, onSave, readOnly = false }) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!open || !data) { setReady(false); return; }
    setReady(true);
  }, [open, data]);

  if (!ready || !data) {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
        PaperProps={{ sx: { borderRadius: 3, display: "flex", alignItems: "center", justifyContent: "center", minHeight: 200 } }}
      >
        <Box sx={{ p: 6 }}>
          <CircularProgress />
        </Box>
      </Dialog>
    );
  }

  return (
    <CustomItemModal
      open={open}
      onClose={onClose}
      onSave={onSave}
      isEditing
      readOnly={readOnly}
      initialTypeId={data.customBoothItemTypeId}
      initialNamePairs={data.localizedPairs?.values || []}
      initialDescriptionPairs={data.descriptionPairs?.values || []}
      initialImagePairs={data.correspondingMedia?.linkLocalizations || []}
      initialLinks={data.links || []}
      initialStartDateTime={data.startDateTime}
      initialEndDateTime={data.endDateTime}
    />
  );
};

export default EditCustomBoothItemModal;
